import { useListContext, usePermissions } from 'react-admin';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import UnassignedField from '@/components/global/fields/UnassignedField.jsx';
import { setPendingFilterReferenceRecord } from '@/helpers/filters/filterReferenceSeed.js';

const ContractorField = ({ contractor, filterKey = 'contractorId_in' }) => {
    const { setFilters, filterValues, displayedFilters } = useListContext();
    const { permissions } = usePermissions();
    if (!contractor) return <UnassignedField />;
    if (permissions?.isAdmin || permissions?.isBok || permissions?.isPosOwner) {
        return (
            <Box
                sx={{ cursor: 'pointer', '&:hover': { textDecoration: 'underline' } }}
                onClick={e => {
                    e.stopPropagation();
                    setPendingFilterReferenceRecord(filterKey, contractor);
                    setFilters({ ...filterValues, [filterKey]: [contractor.id] }, { ...displayedFilters, [filterKey]: true }, false);
                }}
            >
                {contractor.name}
            </Box>
        );
    }
    return contractor.name;
};

ContractorField.propTypes = {
    contractor: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        name: PropTypes.string,
    }),
    filterKey: PropTypes.string,
};

export default ContractorField;
